import { mapEnumToSelectOptions } from '@hclinear/hc-linear-react';
import { FormField, FormFieldType, SelectOption } from '@/type';
import {
  FlatBuffersVersionDTO,
  PromptTypeDTO,
  TerminalLogDirectionDTO,
  TerminalLogStatusDTO,
} from '@/model';
import { t } from '@/localization/i18n';

const seekDefaultOption = (options: SelectOption[]) => [
  { label: t('common.choose'), value: null },
  ...options,
];

const promptTypeOptions: SelectOption[] = Object.values(PromptTypeDTO).map((value) => ({
  value,
  label: value,
}));

export const terminalLogFilterFormFields = (): FormField[] => [
  {
    type: FormFieldType.Select,
    label: t('product-log.filter.flat-buffers-version-id'),
    name: 'flatBuffersVersion',
    xs: 3,
    options: seekDefaultOption(mapEnumToSelectOptions(FlatBuffersVersionDTO, 'enum.')),
  },
  {
    type: FormFieldType.Select,
    label: t('terminal-debug-modal.table.header.message-direction'),
    name: 'messageDirection',
    xs: 3,
    options: seekDefaultOption(mapEnumToSelectOptions(TerminalLogDirectionDTO, 'enum.')),
  },
  {
    type: FormFieldType.Select,
    label: t('product-log.filter.terminal-log-status.status'),
    name: 'status',
    xs: 3,
    options: seekDefaultOption(mapEnumToSelectOptions(TerminalLogStatusDTO, 'enum.')),
  },
  {
    type: FormFieldType.Select,
    label: t('product-log.filter.prompt-type.type'),
    name: 'promptType',
    xs: 3,
    options: seekDefaultOption(promptTypeOptions),
  },

  {
    type: FormFieldType.DateTime,
    label: t('product-log.filter.insert-time-equals'),
    name: 'insertTimeEquals',
    xs: 3,
  },
  {
    type: FormFieldType.DateTime,
    label: t('product-log.filter.insert-time-less-then'),
    name: 'insertTimeLessThen',
    xs: 3,
  },
  {
    type: FormFieldType.DateTime,
    label: t('product-log.filter.insert-time-greater-then'),
    name: 'insertTimeGreaterThen',
    xs: 3,
  },
  {
    type: FormFieldType.Number,
    label: t('product-log.filter.data-size-equals'),
    name: 'dataSizeEquals',
    xs: 3,
  },
  {
    type: FormFieldType.Number,
    label: t('product-log.filter.data-size-less-then'),
    name: 'dataSizeLessThen',
    xs: 3,
  },
  {
    type: FormFieldType.Number,
    label: t('product-log.filter.data-size-greater-then'),
    name: 'dataSizeGreaterThen',
    xs: 3,
  },
  {
    type: FormFieldType.Number,
    label: t('product-log.filter.transfer-time-equals'),
    name: 'transferTimeEquals',
    xs: 3,
  },
  {
    type: FormFieldType.Number,
    label: t('product-log.filter.transfer-time-less-then'),
    name: 'transferTimeLessThen',
    xs: 3,
  },
  {
    type: FormFieldType.Number,
    label: t('product-log.filter.transfer-time-greater-then'),
    name: 'transferTimeGreaterThen',
    xs: 3,
  },
];
